<template>
  <base-card color="accent" v-if="lift.id" class="column-banner">
    <base-container :grid-list-xl="isMobile" :grid-list-xxxl="!isMobile">
      <v-layout row wrap pa-3 align-center>
        <v-flex xs12 sm12 md6>
          <tk-media
            class="grey lighten-2"
            width="100%"
            :media="bannerMedia"
            :style="{'background-color': bannerMedia.color }"
          />
        </v-flex>
        <v-flex xs12 sm12 md6>
          <h1 v-if="title" class="font-weight-medium font-miller-display" v-html="title"></h1>

          <div class="my-4 pre-wrap" v-if="description" v-html="description"></div>

          <tk-btn
            class="ma-0"
            v-if="btn_title"
            dark
            color="black"
            large
            :to="lift.is_redirectable ? null : { path: lift.path}"
            :href="lift.is_redirectable ? lift.url : null"
            :target="lift.is_redirectable ? '_blank' : null"
            :rel="lift.is_redirectable ? 'noreferrer' : null"
          >
            <span class="caption font-weight-medium">{{ btn_title }}</span>
          </tk-btn>
        </v-flex>
      </v-layout>
    </base-container>
  </base-card>
</template>

<script>
export default {
  props: {
    lift: {
      required: true,
    },
  },

  computed: {
    bannerMedia() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return this.lift.mobile_media || {};
      }
      return this.lift.desktop_media || {};
    },
    title() {
      return this.getLocalizedText("title").replace(/&nbsp;/g, " ");
    },

    subtitle() {
      return this.getLocalizedText("subtitle").replace(/&nbsp;/g, " ");
    },

    btn_title() {
      return this.getLocalizedText("btn_title").replace(/&nbsp;/g, " ");
    },

    description() {
      return this.getLocalizedText("description");
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },

  methods: {
    getLocalizedText(item) {
      if (
        typeof this.lift[item] === "string" ||
        this.lift[item] instanceof String
      ) {
        return this.lift[item];
      }

      console.log("getLocalizedText", this.lift);

      if (!this.lift[item]) return null;

      // If text has localized
      const localizedText = this.lift[item][this.$i18n.locale];
      if (localizedText) return localizedText;

      // If not localized title return fallback
      switch (this.$i18n.locale) {
        case "en":
          return this.lift[item]["fi"] || this.lift[item]["se"];
        case "fi":
          return this.lift[item]["en"] || this.lift[item]["se"];
        case "se":
          return this.lift[item]["en"] || this.lift[item]["fi"];
      }

      return null;
    },
  },
};
</script>

<style lang="scss">
.column-banner {
  h1 {
    font-size: 2.3rem;
    line-height: 100%;
  }
  p {
    margin-bottom: 8px;
  }
}
</style>